/*
 * @author  Agence Dn'D <contact@dnd.fr>
 * @license https://opensource.org/licenses/osl-3.0.php  Open Software License (OSL 3.0)
 * @link    https://www.dnd.fr/
 */

class ProductBlockAddToCart {
    constructor() {
        this.boundHandleClick = this.handleClick.bind(this);
        this.init();
    }

    init() {
        document.addEventListener("click", this.boundHandleClick);
    }

    /**
     * @param {MouseEvent} event
     */
    handleClick(event) {
        const button = event.target.closest(".product-block-add-to-cart");
        if (!button || button.disabled || button.getAttribute("aria-disabled") === "true") {
            return;
        }

        event.preventDefault();
        this.addToCart(button);
    }

    /**
     * @param {HTMLButtonElement} button
     */
    async addToCart(button) {
        const variantId = button.dataset.variantId;
        if (!variantId) return;

        button.setAttribute("aria-disabled", "true");
        button.classList.add("is-loading");

        const formData = new FormData();
        formData.append("id", variantId);
        formData.append("quantity", "1");

        if (button.dataset.estimatedDelivery && button.dataset.estimatedDeliveryLabel) {
            formData.append(
                `properties[${button.dataset.estimatedDeliveryLabel}]`,
                button.dataset.estimatedDelivery
            );
        }

        const sectionsToUpdate = ["page-header", "cart-drawer"]
            .map((selector) => document.querySelector(selector))
            .filter((element) => element);
        const sectionIds = sectionsToUpdate.map((element) => element.dataset.sectionId);

        formData.append("sections_url", window.location.pathname);
        formData.append("sections", sectionIds.join(","));

        try {
            const response = await fetch(theme.routes.cartAdd, {
                method: "POST",
                headers: {
                    Accept: "application/javascript",
                    "X-Requested-With": "XMLHttpRequest",
                },
                body: formData,
            });

            const data = await response.json();

            if (!response.ok || data.status) {
                this.handleError(button, data);
                return;
            }

            if (document.querySelector(".template-cart")) {
                const cartForm = document.querySelector("cart-form");
                if (cartForm && cartForm.enableAjaxUpdate) {
                    cartForm.refresh();
                }
            } else if (theme.settings.afterAddToCart === "page") {
                setTimeout(() => {
                    window.location.href = theme.routes.cart;
                }, 300);
            } else {
                if (data.sections && sectionsToUpdate.length === Object.keys(data.sections).length) {
                    sectionsToUpdate.forEach((element) => {
                        element.updateFromCartChange(data.sections[element.dataset.sectionId]);
                    });
                } else {
                    document.dispatchEvent(new CustomEvent("on:cart:change", { bubbles: true }));
                }

                if (theme.settings.afterAddToCart === "notification") {
                    const template = document.getElementById("AddedNotification");
                    if (template) {
                        const notification = template.content.firstElementChild.cloneNode(true);
                        notification.dataset.productTitle = data.product_title;
                        let notificationContainer = document.querySelector(".pageheader--sticky");
                        if (!notificationContainer) {
                            notificationContainer = document.querySelector("body");
                        }
                        notificationContainer.appendChild(notification);
                    }
                } else if (theme.settings.afterAddToCart === "drawer") {
                    const cartDrawer = document.querySelector(".js-cart-drawer");
                    if (cartDrawer) {
                        cartDrawer.open(button);
                    }
                }
            }

            document.dispatchEvent(
                new CustomEvent("on:cart:add", {
                    bubbles: true,
                    detail: {
                        variantId: data.variant_id,
                    },
                })
            );

            button.classList.add("is-success");
            button.removeAttribute("aria-disabled");
            setTimeout(() => {
                button.classList.remove("is-loading");
                button.classList.remove("is-success");
            }, 2000);
        } catch (error) {
            console.error(error);
            button.classList.remove("is-loading");
            button.removeAttribute("aria-disabled");
            document.dispatchEvent(new CustomEvent("on:cart:change", { bubbles: true }));
        }
    }

    /**
     * @param {HTMLButtonElement} button
     * @param {object} data
     */
    handleError(button, data) {
        const soldOutText = button.dataset.soldOutText || theme.strings.noStock;

        button.disabled = true;
        button.classList.add("product-block-add-to-cart--sold-out");
        button.textContent = soldOutText;
        button.classList.remove("is-loading", "is-success");
        button.removeAttribute("aria-disabled");

        document.dispatchEvent(new CustomEvent("on:cart:change", { bubbles: true }));
    }
}

document.addEventListener("DOMContentLoaded", () => {
    new ProductBlockAddToCart();
});
